import { Select, SelectOption } from '@bloomfieldrobotics/canopy';
import { Stack, styled } from '@mui/material';
import { useCallback } from 'react';
import { GradientScale } from '../../../../../commonUI/GradientScale/GradientScale';
import { MapControl } from '../../../../../commonUI/maps/controls';
import { PointColorLegendProps } from '../../../../../commonUI/maps/controls/PointColorLegend';
import { PointColorConfiguration } from '../../../../../commonUI/maps/types';
import { CollectionPoint } from '../../../../types';
import {
  COLOR_CONFIG_MAP,
  ColorablePointPropertyPath,
  EXPOSURE_COLOR_CONFIG,
} from './colorConfigurations';

type Props = PointColorLegendProps & {
  colorConfig: PointColorConfiguration<CollectionPoint>;
  onChange: (newConfig: PointColorConfiguration<CollectionPoint>) => void;
};
export const PointColorizerControl = ({ colorConfig, onChange }: Props) => {
  const handlePropertySelectChange = useCallback(
    (propertyName: ColorablePointPropertyPath) => {
      const newColorConfig =
        COLOR_CONFIG_MAP[propertyName] ?? EXPOSURE_COLOR_CONFIG;
      onChange(newColorConfig);
    },
    [onChange]
  );

  return (
    <PositionedMapControl>
      <Stack direction='column' spacing={3}>
        <Select<ColorablePointPropertyPath>
          value={colorConfig.property as ColorablePointPropertyPath}
          options={COLORIZER_MENU_ITEMS}
          onChange={handlePropertySelectChange}
        />
        <GradientScale
          min={colorConfig.min}
          max={colorConfig.max}
          color={colorConfig.color}
        />
      </Stack>
    </PositionedMapControl>
  );
};

const COLORIZER_MENU_ITEMS: SelectOption<ColorablePointPropertyPath>[] = [
  { label: 'Exposure', value: 'exposure' },
];

const PositionedMapControl = styled(MapControl)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  left: theme.spacing(2),
  flex: 1,
  minWidth: 200,
  minHeight: 90,
  padding: theme.spacing(2.5),
}));
